import $http from '@/libs/axios'

export default class CustomWhatsAppAPI {
  static async save(payload: any) {
    return (await $http.post('/service/custom-wp/save-settings', payload)).data
  }

  static async get() {
    return (await $http.get('/service/custom-wp/settings')).data
  }

  static async sendTest(payload: any) {
    return (await $http.post('/service/custom-wp/send-test', payload)).data
  }
}
